import { closeDrawerPane, hasActiveDrawerPane } from 'owa-drawer';
import { flexPaneClosed } from 'owa-suite-header-apis';
import { triggerResizeEvent } from 'owa-resize-event';

export default function closeAppPane(
    paneId: string,
    targetWindow?: Window,
    wasDrawerPaneClosed?: boolean
): void {
    const paneClosed = closeDrawerPane(
        paneId,
        targetWindow,
        false /* do not dispatch close action */
    );
    flexPaneClosed(paneId);

    if (paneClosed || (wasDrawerPaneClosed && !hasActiveDrawerPane(targetWindow))) {
        triggerResizeEvent();
    }
}
